import { RefreshCw, X } from 'lucide-react'
import { Button } from './ui/button'

export function UpdateBanner({ onUpdate, onDismiss, isUpdating }) {
  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[100] animate-in slide-in-from-top duration-300"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-3 shadow-lg">
        <div className="max-w-lg mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
              <RefreshCw className={`w-4 h-4 ${isUpdating ? 'animate-spin' : ''}`} />
            </div>
            <p className="text-sm font-medium truncate">
              {isUpdating ? 'Actualizando...' : 'Hay una nueva versión disponible'}
            </p>
          </div>
          
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              onClick={onUpdate}
              disabled={isUpdating}
              size="sm"
              variant="secondary"
              className="bg-white text-blue-600 hover:bg-blue-50 font-semibold rounded-full px-4 h-8"
            >
              {isUpdating ? 'Actualizando...' : 'Actualizar'}
            </Button>
            
            {!isUpdating && (
              <button
                onClick={onDismiss}
                className="p-1.5 rounded-full hover:bg-white/20 transition-colors"
                aria-label="Cerrar"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
